/* ==========================================================================
   Productfoto's vergroten (lightbox met zoom)

   Klik of tik op de foto in <ds-gallery data-ds-lightbox> (of op het
   vergrootglas) en de foto opent schermvullend, zonder labels erop.
   - Desktop: klik = in-/uitzoomen op die plek, scrollwiel = traploos zoomen,
     slepen = verschuiven, pijltjestoetsen = vorige/volgende, Esc = sluiten.
   - Mobiel: dubbeltik = in-/uitzoomen, knijpen = traploos zoomen, vegen =
     vorige/volgende, omlaag vegen = sluiten, terugknop van de telefoon sluit.
   De foto opent eerst met de al geladen versie en wisselt dan naar een
   scherpe versie van 2400px (data-ds-full).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__dsLightbox) return;
  window.__dsLightbox = true;

  var MAX_SCALE = 4;
  var TAP_SCALE = 2.5;

  var lb, stage, img, countEl, thumbsEl, prevBtn, nextBtn, zoomBtn, closeBtn, hintEl;
  var gallery = null;
  var slides = [];
  var index = 0;
  var isOpen = false;
  var lastFocus = null;
  var pushedState = false;

  var scale = 1, tx = 0, ty = 0;
  var pointers = new Map();
  var gesture = null;
  var lastTap = { t: 0, x: 0, y: 0 };
  var tapTimer = null;

  var ICON = {
    close: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"></path></svg>',
    zoom: '<svg class="ds-lb__ico-in" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"></circle><path d="M15.5 15.5L20 20M10.5 8v5M8 10.5h5"></path></svg>' +
          '<svg class="ds-lb__ico-out" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"></circle><path d="M15.5 15.5L20 20M8 10.5h5"></path></svg>',
    prev: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 6l-6 6 6 6"></path></svg>',
    next: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M10 6l6 6-6 6"></path></svg>'
  };

  function label(name, fallback) {
    var v = gallery && gallery.getAttribute('data-lb-' + name);
    return v && v.indexOf('translation missing') === -1 ? v : fallback;
  }

  /* ---------- Opbouw ---------- */
  function build() {
    if (lb) return;
    lb = document.createElement('div');
    lb.className = 'ds-lb';
    lb.hidden = true;
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.innerHTML =
      '<div class="ds-lb__top">' +
        '<span class="ds-lb__count" aria-live="polite"></span>' +
        '<div class="ds-lb__tools">' +
          '<button type="button" class="ds-lb__btn" data-lb-zoom>' + ICON.zoom + '</button>' +
          '<button type="button" class="ds-lb__btn" data-lb-close>' + ICON.close + '</button>' +
        '</div>' +
      '</div>' +
      '<div class="ds-lb__stage"><img class="ds-lb__img" alt="" draggable="false"></div>' +
      '<button type="button" class="ds-lb__nav ds-lb__nav--prev">' + ICON.prev + '</button>' +
      '<button type="button" class="ds-lb__nav ds-lb__nav--next">' + ICON.next + '</button>' +
      '<div class="ds-lb__hint"></div>' +
      '<div class="ds-lb__thumbs"></div>';
    document.body.appendChild(lb);

    stage = lb.querySelector('.ds-lb__stage');
    img = lb.querySelector('.ds-lb__img');
    countEl = lb.querySelector('.ds-lb__count');
    thumbsEl = lb.querySelector('.ds-lb__thumbs');
    prevBtn = lb.querySelector('.ds-lb__nav--prev');
    nextBtn = lb.querySelector('.ds-lb__nav--next');
    zoomBtn = lb.querySelector('[data-lb-zoom]');
    closeBtn = lb.querySelector('[data-lb-close]');
    hintEl = lb.querySelector('.ds-lb__hint');

    closeBtn.addEventListener('click', function () { close(); });
    prevBtn.addEventListener('click', function () { show(index - 1); });
    nextBtn.addEventListener('click', function () { show(index + 1); });
    zoomBtn.addEventListener('click', function () {
      if (scale > 1) zoomTo(1, 0, 0, true);
      else zoomTo(TAP_SCALE, 0, 0, true);
    });
    thumbsEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lb-go]');
      if (b) show(parseInt(b.getAttribute('data-lb-go'), 10));
    });

    stage.addEventListener('pointerdown', onDown);
    stage.addEventListener('pointermove', onMove);
    stage.addEventListener('pointerup', onUp);
    stage.addEventListener('pointercancel', onUp);
    stage.addEventListener('wheel', onWheel, { passive: false });
    document.addEventListener('keydown', function (e) { if (isOpen) onKey(e); });
    window.addEventListener('resize', function () {
      if (!isOpen) return;
      fit();
      resetZoom(false);
    });
    window.addEventListener('popstate', function () {
      if (isOpen && pushedState) {
        pushedState = false;
        close(true);
      }
    });
  }

  function setLabels() {
    lb.setAttribute('aria-label', label('title', document.title));
    closeBtn.setAttribute('aria-label', label('close', 'Sluiten'));
    prevBtn.setAttribute('aria-label', label('prev', 'Vorige foto'));
    nextBtn.setAttribute('aria-label', label('next', 'Volgende foto'));
    hintEl.textContent = label('hint', 'Dubbeltik of knijp om in te zoomen');
    updateZoomLabel();
  }

  function updateZoomLabel() {
    zoomBtn.setAttribute('aria-label', scale > 1 ? label('zoom-out', 'Uitzoomen') : label('zoom-in', 'Inzoomen'));
  }

  /* ---------- Openen / sluiten ---------- */
  function open(g) {
    gallery = g;
    slides = Array.prototype.slice.call(g.querySelectorAll('.ds-gallery__stage img[data-ds-slide]'));
    if (!slides.length) return;
    build();
    setLabels();

    thumbsEl.innerHTML = '';
    if (slides.length > 1) {
      slides.forEach(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ds-lb__thumb';
        b.setAttribute('data-lb-go', i);
        b.setAttribute('aria-label', (i + 1) + ' / ' + slides.length);
        var t = document.createElement('img');
        t.src = s.getAttribute('data-ds-thumb') || s.currentSrc || s.src;
        t.alt = '';
        t.loading = 'lazy';
        b.appendChild(t);
        thumbsEl.appendChild(b);
      });
    }
    thumbsEl.hidden = slides.length < 2;
    prevBtn.hidden = nextBtn.hidden = slides.length < 2;

    lastFocus = document.activeElement;
    isOpen = true;
    document.documentElement.classList.add('ds-lb-open');
    lb.hidden = false;
    show(typeof g.i === 'number' ? g.i : 0);
    void lb.offsetWidth; /* reflow, zodat de fade-in start */
    lb.classList.add('is-open');
    closeBtn.focus({ preventScroll: true });

    try {
      history.pushState({ dsLightbox: true }, '');
      pushedState = true;
    } catch (e) { pushedState = false; }

    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    var seen = false;
    try { seen = sessionStorage.getItem('ds:lb-hint') === '1'; } catch (e) {}
    if (coarse && !seen) {
      hintEl.classList.add('is-visible');
      setTimeout(function () { hintEl.classList.remove('is-visible'); }, 2600);
      try { sessionStorage.setItem('ds:lb-hint', '1'); } catch (e) {}
    }
  }

  function close(fromHistory) {
    if (!isOpen) return;
    isOpen = false;
    clearTimeout(tapTimer);
    pointers.clear();
    gesture = null;
    lb.classList.remove('is-open', 'is-zoomed', 'is-dragging');
    document.documentElement.classList.remove('ds-lb-open');
    if (gallery && typeof gallery.go === 'function') gallery.go(index);
    setTimeout(function () { if (!isOpen) lb.hidden = true; }, 230);
    if (!fromHistory && pushedState) {
      pushedState = false;
      try { history.back(); } catch (e) {}
    }
    if (lastFocus && lastFocus.focus) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  /* ---------- Foto tonen ---------- */
  function show(i) {
    var n = slides.length;
    index = ((i % n) + n) % n;
    var s = slides[index];
    resetZoom(false);

    img.src = s.currentSrc || s.src;
    img.alt = s.alt || '';
    fit();

    var full = s.getAttribute('data-ds-full');
    if (full && full !== img.src) {
      var want = index;
      var pre = new Image();
      pre.onload = function () { if (isOpen && index === want) img.src = full; };
      pre.src = full;
    }

    countEl.textContent = n > 1 ? (index + 1) + ' / ' + n : '';
    Array.prototype.forEach.call(thumbsEl.children, function (b, bi) {
      var cur = bi === index;
      b.classList.toggle('is-current', cur);
      b.setAttribute('aria-current', cur ? 'true' : 'false');
      if (cur && b.scrollIntoView) b.scrollIntoView({ block: 'nearest', inline: 'center' });
    });
  }

  /* De foto passend maken binnen het vlak (zoals object-fit: contain). We
     zetten breedte en hoogte zelf, zodat de foto niet verspringt als de
     scherpe versie inlaadt. */
  function fit() {
    var s = slides[index];
    if (!s) return;
    var nw = parseFloat(s.getAttribute('width')) || s.naturalWidth || 1;
    var nh = parseFloat(s.getAttribute('height')) || s.naturalHeight || 1;
    var pad = window.innerWidth < 750 ? 0 : 24;
    var W = Math.max(50, stage.clientWidth - pad * 2);
    var H = Math.max(50, stage.clientHeight - pad * 2);
    var r = nw / nh;
    var w, h;
    if (W / H > r) { h = H; w = H * r; } else { w = W; h = W / r; }
    img.style.width = Math.round(w) + 'px';
    img.style.height = Math.round(h) + 'px';
  }

  /* ---------- Zoomen en verschuiven ---------- */
  function apply(animate) {
    img.style.transition = animate ? 'transform .28s cubic-bezier(.32,.72,.24,1)' : 'none';
    img.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + scale + ')';
    lb.classList.toggle('is-zoomed', scale > 1.01);
    updateZoomLabel();
  }

  function clampPan() {
    var w = img.offsetWidth * scale;
    var h = img.offsetHeight * scale;
    var maxX = Math.max(0, (w - stage.clientWidth) / 2);
    var maxY = Math.max(0, (h - stage.clientHeight) / 2);
    tx = Math.min(maxX, Math.max(-maxX, tx));
    ty = Math.min(maxY, Math.max(-maxY, ty));
  }

  /* px/py: punt ten opzichte van het midden van het vlak dat op zijn plek blijft. */
  function zoomTo(next, px, py, animate) {
    next = Math.min(MAX_SCALE, Math.max(1, next));
    tx = px - (px - tx) * (next / scale);
    ty = py - (py - ty) * (next / scale);
    scale = next;
    if (scale <= 1.001) { scale = 1; tx = 0; ty = 0; }
    clampPan();
    apply(animate);
  }

  function resetZoom(animate) {
    scale = 1; tx = 0; ty = 0;
    if (img) apply(animate);
  }

  function rel(x, y) {
    var r = stage.getBoundingClientRect();
    return { x: x - (r.left + r.width / 2), y: y - (r.top + r.height / 2) };
  }

  function onImage(x, y) {
    var r = img.getBoundingClientRect();
    return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  }

  function pinchData() {
    var p = Array.from(pointers.values());
    var dx = p[1].x - p[0].x, dy = p[1].y - p[0].y;
    return { d: Math.hypot(dx, dy) || 1, mid: rel((p[0].x + p[1].x) / 2, (p[0].y + p[1].y) / 2) };
  }

  function startPan(x, y) {
    gesture = { type: 'pan', sx: x, sy: y, stx: tx, sty: ty, moved: false, dx: 0, dy: 0 };
  }

  function onDown(e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    try { stage.setPointerCapture(e.pointerId); } catch (err) {}
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pointers.size === 1) {
      startPan(e.clientX, e.clientY);
    } else if (pointers.size === 2) {
      var pd = pinchData();
      gesture = { type: 'pinch', d0: pd.d, s0: scale, m0: pd.mid, tx0: tx, ty0: ty };
    }
  }

  function onMove(e) {
    if (!pointers.has(e.pointerId)) return;
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (!gesture) return;

    if (gesture.type === 'pinch' && pointers.size >= 2) {
      var pd = pinchData();
      var next = Math.min(MAX_SCALE, Math.max(1, gesture.s0 * (pd.d / gesture.d0)));
      tx = pd.mid.x - (gesture.m0.x - gesture.tx0) * (next / gesture.s0);
      ty = pd.mid.y - (gesture.m0.y - gesture.ty0) * (next / gesture.s0);
      scale = next;
      clampPan();
      apply(false);
      return;
    }

    if (gesture.type === 'pan') {
      gesture.dx = e.clientX - gesture.sx;
      gesture.dy = e.clientY - gesture.sy;
      if (Math.abs(gesture.dx) + Math.abs(gesture.dy) > 6) gesture.moved = true;
      if (!gesture.moved) return;
      if (scale > 1) {
        lb.classList.add('is-dragging');
        tx = gesture.stx + gesture.dx;
        ty = gesture.sty + gesture.dy;
        clampPan();
        apply(false);
      } else if (slides.length > 1 || gesture.dy > 0) {
        /* Niet ingezoomd: foto beweegt mee met het vegen. */
        var horizontal = Math.abs(gesture.dx) > Math.abs(gesture.dy);
        tx = horizontal ? gesture.dx : 0;
        ty = horizontal ? 0 : Math.max(0, gesture.dy);
        img.style.transition = 'none';
        img.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0)';
        img.style.opacity = horizontal ? '' : String(Math.max(.4, 1 - ty / 400));
      }
    }
  }

  function onUp(e) {
    if (!pointers.has(e.pointerId)) return;
    pointers.delete(e.pointerId);
    lb.classList.remove('is-dragging');

    if (gesture && gesture.type === 'pinch') {
      if (pointers.size === 1) {
        var p = pointers.values().next().value;
        startPan(p.x, p.y);
        gesture.moved = true;
      } else if (pointers.size === 0) {
        gesture = null;
        if (scale < 1.05) resetZoom(true);
      }
      return;
    }
    if (!gesture || pointers.size > 0) return;

    var g = gesture;
    gesture = null;
    img.style.opacity = '';

    if (e.type === 'pointercancel') {
      if (scale <= 1) resetZoom(true);
      return;
    }

    if (!g.moved) {
      handleTap(e);
      return;
    }

    if (scale <= 1) {
      if (Math.abs(g.dx) > Math.abs(g.dy) && Math.abs(g.dx) > 50 && slides.length > 1) {
        show(index + (g.dx < 0 ? 1 : -1));
      } else if (g.dy > 90 && g.dy > Math.abs(g.dx)) {
        close();
      } else {
        resetZoom(true);
      }
    }
  }

  function handleTap(e) {
    var pt = rel(e.clientX, e.clientY);
    var hitImage = onImage(e.clientX, e.clientY);

    if (e.pointerType === 'mouse') {
      if (scale > 1) zoomTo(1, 0, 0, true);
      else if (hitImage) zoomTo(TAP_SCALE, pt.x, pt.y, true);
      else close();
      return;
    }

    /* Aanraken: dubbeltik zoomt; een enkele tik naast de foto sluit. */
    var now = Date.now();
    var near = Math.hypot(e.clientX - lastTap.x, e.clientY - lastTap.y) < 40;
    if (now - lastTap.t < 300 && near) {
      clearTimeout(tapTimer);
      lastTap.t = 0;
      if (scale > 1) zoomTo(1, 0, 0, true);
      else zoomTo(TAP_SCALE, pt.x, pt.y, true);
      return;
    }
    lastTap = { t: now, x: e.clientX, y: e.clientY };
    clearTimeout(tapTimer);
    if (!hitImage && scale <= 1) {
      tapTimer = setTimeout(function () { if (isOpen) close(); }, 300);
    }
  }

  function onWheel(e) {
    e.preventDefault();
    var pt = rel(e.clientX, e.clientY);
    var speed = e.ctrlKey ? 0.01 : 0.0022;
    zoomTo(scale * Math.exp(-e.deltaY * speed), pt.x, pt.y, false);
  }

  function onKey(e) {
    switch (e.key) {
      case 'Escape':
        e.preventDefault();
        if (scale > 1) zoomTo(1, 0, 0, true); else close();
        break;
      case 'ArrowLeft':
        if (scale > 1) { tx += 60; clampPan(); apply(true); } else if (slides.length > 1) show(index - 1);
        e.preventDefault();
        break;
      case 'ArrowRight':
        if (scale > 1) { tx -= 60; clampPan(); apply(true); } else if (slides.length > 1) show(index + 1);
        e.preventDefault();
        break;
      case 'ArrowUp':
        if (scale > 1) { ty += 60; clampPan(); apply(true); e.preventDefault(); }
        break;
      case 'ArrowDown':
        if (scale > 1) { ty -= 60; clampPan(); apply(true); e.preventDefault(); }
        break;
      case '+':
      case '=':
        zoomTo(scale * 1.5, 0, 0, true);
        e.preventDefault();
        break;
      case '-':
        zoomTo(scale / 1.5, 0, 0, true);
        e.preventDefault();
        break;
      case 'Tab':
        var f = Array.prototype.filter.call(lb.querySelectorAll('button'), function (b) {
          return !b.hidden && b.offsetParent !== null;
        });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        break;
    }
  }

  /* ---------- Openen vanaf de productpagina ---------- */
  var touchStart = null;
  var touchMoved = false;
  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest || !e.target.closest('ds-gallery[data-ds-lightbox] .ds-gallery__stage')) return;
    touchStart = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    touchMoved = false;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!touchStart) return;
    var t = e.touches[0];
    if (Math.abs(t.clientX - touchStart.x) + Math.abs(t.clientY - touchStart.y) > 10) touchMoved = true;
  }, { passive: true });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var g = t.closest('ds-gallery[data-ds-lightbox]');
    if (!g) return;
    var btn = t.closest('[data-ds-lb-open]');
    if (!btn) {
      if (!t.closest('.ds-gallery__stage')) return;
      if (t.closest('button, a')) return; /* pijlen en stippen blijven gewoon werken */
      if (touchMoved) { touchMoved = false; return; } /* dat was een veeg, geen tik */
    }
    e.preventDefault();
    open(g);
  });
})();
